/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from "./routes/__root";
import { Route as PreviewImport } from "./routes/Preview";
import { Route as OmroepIndexImport } from "./routes/$omroep/index";
import { Route as OmroepOverviewImport } from "./routes/$omroep/Overview";

// Create/Update Routes

const PreviewRoute = PreviewImport.update({
  path: "/Preview",
  getParentRoute: () => rootRoute
} as any);

const OmroepIndexRoute = OmroepIndexImport.update({
  path: "/$omroep/",
  getParentRoute: () => rootRoute
} as any);

const OmroepOverviewRoute = OmroepOverviewImport.update({
  path: "/$omroep/Overview",
  getParentRoute: () => rootRoute
} as any);

// Populate the FileRoutesByPath interface

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/Preview": {
      id: "/Preview";
      path: "/Preview";
      fullPath: "/Preview";
      preLoaderRoute: typeof PreviewImport;
      parentRoute: typeof rootRoute;
    };
    "/$omroep/Overview": {
      id: "/$omroep/Overview";
      path: "/$omroep/Overview";
      fullPath: "/$omroep/Overview";
      preLoaderRoute: typeof OmroepOverviewImport;
      parentRoute: typeof rootRoute;
    };
    "/$omroep/": {
      id: "/$omroep/";
      path: "/$omroep";
      fullPath: "/$omroep";
      preLoaderRoute: typeof OmroepIndexImport;
      parentRoute: typeof rootRoute;
    };
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  "/Preview": typeof PreviewRoute;
  "/$omroep/Overview": typeof OmroepOverviewRoute;
  "/$omroep": typeof OmroepIndexRoute;
}

export interface FileRoutesByTo {
  "/Preview": typeof PreviewRoute;
  "/$omroep/Overview": typeof OmroepOverviewRoute;
  "/$omroep": typeof OmroepIndexRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  "/Preview": typeof PreviewRoute;
  "/$omroep/Overview": typeof OmroepOverviewRoute;
  "/$omroep/": typeof OmroepIndexRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths: "/Preview" | "/$omroep/Overview" | "/$omroep";
  fileRoutesByTo: FileRoutesByTo;
  to: "/Preview" | "/$omroep/Overview" | "/$omroep";
  id: "__root__" | "/Preview" | "/$omroep/Overview" | "/$omroep/";
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  PreviewRoute: typeof PreviewRoute;
  OmroepOverviewRoute: typeof OmroepOverviewRoute;
  OmroepIndexRoute: typeof OmroepIndexRoute;
}

const rootRouteChildren: RootRouteChildren = {
  PreviewRoute: PreviewRoute,
  OmroepOverviewRoute: OmroepOverviewRoute,
  OmroepIndexRoute: OmroepIndexRoute
};

export const routeTree = rootRoute._addFileChildren(rootRouteChildren)._addFileTypes<FileRouteTypes>();

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/Preview",
        "/$omroep/Overview",
        "/$omroep/"
      ]
    },
    "/Preview": {
      "filePath": "Preview.tsx"
    },
    "/$omroep/Overview": {
      "filePath": "$omroep/Overview.tsx"
    },
    "/$omroep/": {
      "filePath": "$omroep/index.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
